import { Camera, Wrench, Fingerprint, Lock, BellRing, DoorClosed, ArrowUpRight } from "lucide-react";
import { Reveal, SectionTag } from "./Reveal";

const services = [
  {
    icon: Camera,
    title: "CCTV Installation",
    desc: "CP Plus & Hikvision 4K, IP, dome and bullet cameras — engineered for zero blind spots in homes, shops and godowns.",
    tags: ["4K / IP", "DOME", "BULLET"],
    span: "md:col-span-2",
  },
  {
    icon: Wrench,
    title: "Repair, AMC & Maintenance",
    desc: "Fast fault diagnosis, annual maintenance contracts and uptime support that keeps every camera recording.",
    tags: ["AMC", "SAME-DAY"],
    span: "",
  },
  {
    icon: Fingerprint,
    title: "Biometric Systems",
    desc: "Fingerprint attendance and access control for offices, factories and shops — accurate, tamper-proof logs.",
    tags: ["ACCESS", "ATTENDANCE"],
    span: "",
  },
  {
    icon: Lock,
    title: "Smart Electric Locks",
    desc: "Digital door locks and electronic strike systems installed clean, configured and tested on-site.",
    tags: ["DIGITAL", "KEYLESS"],
    span: "",
  },
  {
    icon: BellRing,
    title: "Video Doorbells",
    desc: "See and speak to visitors from anywhere with smart video doorbells and intercom systems.",
    tags: ["INTERCOM", "MOBILE VIEW"],
    span: "",
  },
  {
    icon: DoorClosed,
    title: "Security Doors",
    desc: "High-impact security doors and perimeter locking hardware for serious physical protection.",
    tags: ["PERIMETER", "HEAVY-DUTY"],
    span: "md:col-span-2",
  },
];

const handleMove = (e) => {
  const r = e.currentTarget.getBoundingClientRect();
  e.currentTarget.style.setProperty("--mx", `${e.clientX - r.left}px`);
  e.currentTarget.style.setProperty("--my", `${e.clientY - r.top}px`);
};

export default function Services() {
  return (
    <section id="services" className="relative py-28 sm:py-36 bg-base" data-testid="services-section">
      <div className="max-w-7xl mx-auto px-5 sm:px-8">
        <Reveal>
          <SectionTag index="01" label="What we deploy" />
          <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight max-w-2xl">
            Six systems. <span className="text-cyan-400">One secured perimeter.</span>
          </h2>
        </Reveal>

        <div className="mt-14 grid grid-cols-1 md:grid-cols-3 gap-4">
          {services.map((s, i) => (
            <Reveal key={s.title} delay={i * 0.08} className={s.span}>
              <div
                onMouseMove={handleMove}
                data-testid={`service-card-${s.title.toLowerCase().replace(/[^a-z]+/g, "-")}`}
                className="spotlight-card group h-full bg-card border border-line rounded-2xl p-7 sm:p-8 transition-colors duration-500 hover:border-cyan-400/40"
              >
                <div className="flex items-start justify-between">
                  <span className="w-12 h-12 rounded-xl bg-cyan-500/10 border border-cyan-400/25 flex items-center justify-center transition-transform duration-500 group-hover:scale-110 group-hover:rotate-3">
                    <s.icon className="w-6 h-6 text-cyan-400" />
                  </span>
                  <ArrowUpRight className="w-5 h-5 text-faint transition-all duration-300 group-hover:text-cyan-400 group-hover:translate-x-1 group-hover:-translate-y-1" />
                </div>
                <h3 className="mt-6 font-display text-xl font-bold text-strong">{s.title}</h3>
                <p className="mt-3 text-sm text-soft leading-relaxed">{s.desc}</p>
                <div className="mt-6 flex flex-wrap gap-2">
                  {s.tags.map((t) => (
                    <span key={t} className="font-mono2 text-[10px] tracking-[0.15em] text-cyan-300/80 border border-cyan-400/20 rounded-full px-3 py-1">
                      {t}
                    </span>
                  ))}
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
